import { AppModules } from 'appContainer/types';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

export const routes = {
  path: '/help-and-support',
  title: 'Help & support',
  appModule: AppModules.HELP_AND_SUPPORT,
  content: async (): PathRouteContent =>
    (await import('./HelpAndSupportPage')).HelpAndSupportPage,
  children: [],
} as const satisfies RouteNode;
